import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import useForm from '../../CustomHooks/FormHook'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import { enterKeyHandler } from '../../../utils'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import TextInput from '../TextInput'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'

export default function DepositionReportForm({ location }) {
  console.log('DepositionReportForm rendered: ', location)

  let init = {
    plaintiffLastName: '',
    plaintiffFirstName: '',
    plaintiffFirm: ''
  }

  const navigate = useNavigate()
  init = initialFormValues('DepositionReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('DepositionReportForm', navigate, inputs, 'njasbestos.deposition_report')
  }

  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Search For A Plaintiff' />
            <tbody>
              <TextInput label='Plaintiff Last Name' name='plaintiffLastName' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffLastName} />
              <TextInput label='Plaintiff First Name' name='plaintiffFirstName' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffFirstName} />
              <CustomSelectListInput label="Plaintiff Firm"  name='plaintiffFirm' handleChange={handleInputChange} modelName="NJAsbestos" entityName="opposing_firm" blankOption={true} defaultValue={inputs.plaintiffFirm} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Search' />
      </form>
    </div>
  )
}
